export default __webpack_public_path__ + "static/media/complementary--lane-control--g3.ade4dcda.png";